import React from 'react';
import {ModalContent, ModalFooter} from "../../../components/Modal";
import {PendingProprietario} from "./controller";
import FieldView from "../../../components/FieldView";
import {IonButton} from "@ionic/react";
import {FazendaObject, getFazendaNomeCompleto} from "../../../models/Fazenda";
import {pessoaTipoChoices} from "../../../models/Proprietario";

interface ConfirmarProps {
  proprietario: PendingProprietario;
  onClickChange: () => void;
  onConfirm: () => void;
  fazenda?: FazendaObject;
}

const Confirmar: React.FC<ConfirmarProps> = (props) => {
  const {proprietario, onConfirm, onClickChange, fazenda} = props;
  const {instance} = proprietario;

  return (
    <>
      <ModalContent>
        {fazenda &&
          <div className="text-2xl mb-6">
            {getFazendaNomeCompleto(fazenda)}
          </div>
        }
        <div className="app-form-step-title">
            Proprietário atual
        </div>

        <div className="flex flex-col gap-4">
          <FieldView value={instance.nome} label="Nome"/>
          <FieldView value={instance.telefone} label="Telefone"/>
          {instance.pessoa_tipo &&
            <FieldView value={pessoaTipoChoices.getLabel(instance.pessoa_tipo)} label="Tipo de cadastro"/>
          }
          {instance.estado &&
            <FieldView value={instance.estado} label="Estado"/>
          }
          {instance.cidade &&
            <FieldView value={instance.cidade} label="Cidade"/>
          }
        </div>
      </ModalContent>
      <ModalFooter>
        <div className="flex items-center gap-4">
          <IonButton
            color="light"
            onClick={onConfirm}
          >
            Voltar
          </IonButton>

          <IonButton
            onClick={onClickChange}
          >
            Alterar
          </IonButton>
        </div>
      </ModalFooter>
    </>
  );
}

export default Confirmar;
